var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8188",
    "data-name": "Rectangle 8188",
    width: 17.57,
    height: 17.57,
    fill: "none",
    stroke: "#007ab9",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29316",
    "data-name": "Group 29316",
    transform: "translate(-515.922 -106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29308",
    "data-name": "Group 29308",
    transform: "translate(-730.078 11409.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(1246 -11303.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29288",
    "data-name": "Group 29288",
    transform: "translate(733 -11604.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27960",
    "data-name": "Group 27960",
    transform: "translate(530.359 309.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27959",
    "data-name": "Group 27959",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27958",
    "data-name": "Group 27958",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27957",
    "data-name": "Group 27957",
    transform: "translate(0.515 0.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49095",
    "data-name": "Path 49095",
    d: "M31.54,23.27A8.27,8.27,0,1,1,23.27,15,8.27,8.27,0,0,1,31.54,23.27Z",
    transform: "translate(-15 -15)",
    fill: "none",
    stroke: "#264151",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49096",
    "data-name": "Path 49096",
    d: "M110.182,115.363a5.182,5.182,0,1,1,5.182-5.182A5.188,5.188,0,0,1,110.182,115.363Z",
    transform: "translate(-101.912 -101.912)",
    fill: "none",
    stroke: "#264153",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49097",
    "data-name": "Path 49097",
    d: "M197.093,199.187a2.093,2.093,0,1,1,2.093-2.093A2.1,2.1,0,0,1,197.093,199.187Z",
    transform: "translate(-188.823 -188.823)",
    fill: "#007ab9",
    stroke: "#007ab9",
    strokeWidth: 1.5
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_49098",
    "data-name": "Path 49098",
    d: "M256,63.055V59.964",
    transform: "translate(283.143 251.899)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49099",
    "data-name": "Path 49099",
    d: "M361.964,256h3.091",
    transform: "translate(180.816 62.59)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49100",
    "data-name": "Path 49100",
    d: "M63.055,256H59.964",
    transform: "translate(472.452 62.59)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49101",
    "data-name": "Path 49101",
    d: "M256.444-49.5v-3.091",
    transform: "translate(282.715 360.592)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49102",
    "data-name": "Path 49102",
    d: "M462.408,253.444H465.5",
    transform: "translate(83.819 65.058)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49103",
    "data-name": "Path 49103",
    d: "M256.444,459.408V462.5",
    transform: "translate(282.715 -133.838)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49105",
    "data-name": "Path 49105",
    d: "M256.444,459.408V462.5",
    transform: "translate(282.699 -137.644)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49104",
    "data-name": "Path 49104",
    d: "M-36.5,253.444h-3.091",
    transform: "translate(568.592 65.058)",
    fill: "#e4e4e4",
    stroke: "#fff",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointHighlighted);
export default __webpack_public_path__ + "static/media/pointHighlighted.6122d7f0a45c90b3d88d51735596e6f2.svg";
export { ForwardRef as ReactComponent };